import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { omit } from "lodash";
import { yupResolver } from "@hookform/resolvers/yup";

import { useFetchOneSubcontractor, useSubmitSubcontractor } from "@bms/hooks";
import { validation } from "./schema";
import { openNotification } from "@bms/components";

export type ReceivedProps = Record<string, any>;

const useSubContractorControl = (props: ReceivedProps) => {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const isView = state?.view || false;
  const {
    data: subcontractorData,
    isSuccess,
    isLoading,
  } = useFetchOneSubcontractor(id);
  const { mutate, isLoading: isSubmitting } = useSubmitSubcontractor();

  const {
    register,
    reset,
    handleSubmit,
    setValue,
    formState: { errors },
    trigger,
  } = useForm({
    resolver: yupResolver(validation()),
  });

  const onSubmit = async (values: Record<string, any>) => {
    if (isView) return;

    mutate(
      {
        payload: id ? values : omit(values, ["id"]),
        subcontractorId: id,
      },
      {
        onSuccess() {
          if (!id) {
            reset();
          }
          openNotification();
          navigate(-1);
        },
      }
    );
  };

  useEffect(() => {
    if (isSuccess) {
      reset(subcontractorData);
    }
  }, [isSuccess, subcontractorData, reset]);

  return {
    ...props,
    id,
    isLoading,
    isSubmitting,
    errors,
    isView,
    setValue,
    register,
    handleSubmit,
    onSubmit,
    trigger,
  };
};

export type Props = ReturnType<typeof useSubContractorControl>;

export default useSubContractorControl;
